<template>
  <v-container fluid tag="section">
    <v-card>
      <v-card-title>
        {{ $t("affiliation_request") }}
      </v-card-title>
      <v-card-text v-if="libertasParams">
        <v-row >
          <v-col cols="3">
            <v-text-field
            :label="$t('code')+' LIBERTAS'"
              v-model="request.codice_affiliazione" 
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              :label="$t('season')"
              :items="libertasParams.esercizi"
              item-text="descr"
              item-value="annoCurEse"
              v-model="request.anno" 
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              :label="$t('type')"
              :items="libertasParams.tipo_affiliazione"
              item-text="descr"
              item-value="id"
              v-model="request.tipo_affiliazione" 
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              :label="$t('affiliation_cards_period')"
              :items="libertasParams.tesseramento_annuale"
              item-text="descr"
              item-value="id"
              v-model="request.tesseramento_annuale" 
            ></v-select>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-autocomplete
              :label="$t('pick_your_disciplines')"
              clearable
              chips
              :items="libertasParams.discipline"
              item-text="descr"
              item-value="idDisciplina"
              multiple
              v-model="request.discipline" 
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn @click="sendAffiliation" color="success">{{
              $t("confirm")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text> 
    </v-card>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import profilePage from "@/app/UserProfile.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import selectModPag from "@/widget/selectModPag.vue";

import Swal from "sweetalert2";
import moment from "moment";

let _ = this;
export default {
  name: "affiliazione-LIBERTAS",
  components: {
    DataTables,
    profilePage,
    MyDatepicker,
    selectModPag,
  },
  data() {
    return {
      listUpdated: null,
      listError: null,
      isAffiliated: false,
      priceAffiliation: 0,
      asdAffiliazione: null,
      params: {
        pagId: null,
        asdAffiliazione: null,
        dettaglio: [],
      },
      request:{
        discipline: [],
        anno: null,
        tipo_affiliazione: null,
        tesseramento_annuale: null,
        codice_affiliazione: null
      },
      libertasParams: {},
    };
  },

  methods: {
    sendAffiliation: function (data) {
      let _ = this;
      _.chiamataAxios(
        "POST",
           "/auth/ente/affiliazioneLIBERTAS",       
        { dialogLoader: true, body: _.request }
      ).then((response) => {
        Swal.fire({
          type: response.msg.esito ? "success" : "error",
          title: response.msg.esito
            ? _.$t("operation_successfully_completed")
            : _.$t("there_was_an_error"),
          html: response.msg.msgTxt,
        });

        if (response.msg.esito) _.$emit("isUpdated", true);;
      });
    },
    loadParams() {
      let _ = this;
      _.libertasParams = {}
      _.isFetching = true;
      _.chiamataAxios("GET", "/auth/ente/getLibertasAffiliationData").then((response) => {
          _.libertasParams = response.data;
          
          _.request.anno = _.libertasParams.currEse;
          _.request.tipo_affiliazione = "A003";
          _.request.tesseramento_annuale = 0;
          _.request.codice_affiliazione =  _.libertasParams.asd_code;
          _.isFetching = false;
      });
    }
  },
  created() {
    this.loadParams();
  },
  computed: {
    enteData: function () {
      return window.systemData.ente;
    },
  },
};
</script>

